module.exports = __webpack_public_path__ + "static/media/5.d3f0cc03.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/stickers/5.png
// module id = 111
// module chunks = 0